import React from "react";
import AccordionItem from "./AccordionItem";

const AccordionTwo= ({items}: {items:any[]}) => {


  return (
    <div className="bg-white dark:border-strokedark dark:bg-boxdark">
      <div className="px-8">
        <div className="flex flex-col gap-7.5">
          {items.map((item:any) => {
            return (<>
              <AccordionItem
                key={item.id}
                faq={item}
              /></>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AccordionTwo;
